export default class Animation {
  /**
   * Like the jQuery slideToggle.
   *
   * CSS needed on element:
   * .[containerSelector] {
   *   transition: height .35s ease-in-out;
   *   overflow: hidden;
   * }
   *
   * .[containerSelector]:not(.active) {
   *   display: none;
   * }
   */
  static slideToggle = (container) => {
    if (!container.classList.contains('active')) {
      container.classList.add('active');
      container.style.height = 'auto';

      const height = container.clientHeight + 'px';

      container.style.height = '0px';

      setTimeout(function () {
        container.style.height = height;
      }, 0);
    } else {
      container.style.height = '0px';

      container.addEventListener(
        'transitionend',
        function () {
          container.classList.remove('active');
        },
        {
          once: true,
        }
      );
    }
  };
}
